// import { Progress, Tooltip } from "antd";
// import { useEffect, useState } from "react";
// import _NewapplicationService from "../../modules/NewapplicationService";

// const ApplicationProgressBar = () => {
//   const [completedPercent, setCompletedPercent] = useState(0);
//   const applicationTypeId = Number(localStorage.getItem("applicationTypeId"));
//   const applicationId = Number(localStorage.getItem("ApplicationObjId"));

//   useEffect(() => {
//     if (applicationId && applicationTypeId) {
//       getApplicationStatusByApplicationId(applicationId);
//     }
//   }, [applicationId, applicationTypeId]);

//   const getApplicationStatusByApplicationId = async (id) => {
//     try {
//       const res = await _NewapplicationService.getApplicationStatusByApplicationId(id);
//       if (res.data?.Obj?.applicationScreenStatus) {
//         const status = res.data.Obj.applicationScreenStatus;
//         const screens = getFilteredScreens(applicationTypeId);
//         const screenMapping = getScreenKeyMapping();

//         let completedCount = 0;

//         // Count completed screens
//         screens.forEach((screen) => {
//           const key = screenMapping[screen];
//           if (status[key] === true) {
//             completedCount += 1;
//           }
//         });

//         const percent = Math.round((completedCount / screens.length) * 100);
//         setCompletedPercent(percent);
//       }
//     } catch (error) {
//       console.error("Error fetching application status", error);
//     }
//   };

//   // Maps screen names to API keys
//   const getScreenKeyMapping = () => ({
//     "Personal Details": "IsAapplicationDetailsCompleted",
//     "Proof Of Trust": "IsProofofTrustCompleted",
//     "Identification Details": "IsAapplicationIdentificationCompleted",
//     "Cob Details": "IsCoborrowerDetailsCompleted",
//     "Cob Identification": "IsCoborrowerIdentificationCompleted",
//     "Document Upload": "IsDocumentUploadCompleted",
//     "Income Source": "IsIncomesourceCompleted",
//     "Expenses": "IsExpensesCompleted",
//     "Balance Sheet Asset": "IsBalancesheetAssetCompleted",
//     "Balance Sheet Total Asset": "IsBalancesheetTotalAssetCompleted",
//     "Balance Sheet Total Liability": "IsBalancesheetTotalLiabiltyCompleted",
//     "Questionnaire": "IsQuestionairCompleted"
//   });

//   // Screens per applicationTypeId
//   const getFilteredScreens = (typeId) => {
//     switch (typeId) {
//       case 1:
//         return [
//           "Personal Details",
//           "Identification Details",
//           "Document Upload",
//           "Income Source",
//           "Expenses",
//           "Balance Sheet Asset",
//           "Balance Sheet Total Asset",
//           "Balance Sheet Total Liability",
//           "Questionnaire"
//         ];
//       case 4:
//         return [
//           "Personal Details",
//           "Identification Details",
//           "Cob Details",
//           "Cob Identification",
//           "Document Upload",
//           "Income Source",
//           "Expenses",
//           "Balance Sheet Asset",
//           "Balance Sheet Total Asset",
//           "Balance Sheet Total Liability",
//           "Questionnaire"
//         ];
//       case 3:
//         return [
//           "Personal Details",
//           "Proof Of Trust",
//           "Identification Details",
//           "Document Upload",
//           "Income Source",
//           "Expenses",
//           "Balance Sheet Asset",
//           "Balance Sheet Total Asset",
//           "Balance Sheet Total Liability",
//           "Questionnaire"
//         ];
//       case 2:
//         return [
//           "Personal Details",
//           "Proof Of Trust",
//           "Document Upload",
//           "Income Source",
//           "Expenses",
//           "Balance Sheet Asset",
//           "Balance Sheet Total Asset",
//           "Balance Sheet Total Liability",
//           "Questionnaire"
//         ];
//       default:
//         return [];
//     }
//   };

//   return (
//     <>
//     <Tooltip title={`Application Workflow Progress: ${completedPercent}%`}>
//       <Progress style={{marginBottom:"2px"}} percent={completedPercent}  format={(percent) => `${percent}%`}  />
//       </Tooltip>
//     </>
//   );
// };

// export default ApplicationProgressBar;


import { Progress, Tooltip } from "antd";
import { useEffect, useState } from "react";
import _NewapplicationService from "../../modules/NewapplicationService";
import "./ApplicationProgressBar.scss";

const ApplicationProgressBar = () => {
  const [completedPercent, setCompletedPercent] = useState(0);
  const [completedSteps, setCompletedSteps] = useState(0);
  const [totalSteps, setTotalSteps] = useState(0);

  const applicationTypeId = Number(localStorage.getItem("applicationTypeId"));
  const applicationId = Number(localStorage.getItem("ApplicationObjId"));

  useEffect(() => {
    if (applicationId && applicationTypeId) {
      const screens = getFilteredScreens(applicationTypeId);
      setTotalSteps(screens.length);
      getApplicationStatusByApplicationId(applicationId, screens);
    }
  }, [applicationId, applicationTypeId]);

  const getApplicationStatusByApplicationId = async (id, screens) => {
    try {
      const res =
        await _NewapplicationService.getApplicationStatusByApplicationId(id);

      const status = res?.data?.Obj?.applicationScreenStatus;
      if (!status) return;

      // ✅ If backend confirms everything is completed
      if (status.IsAllStepsCompleted === true) {
        setCompletedSteps(screens.length);
        setCompletedPercent(100);
        return;
      }

      const screenMapping = getScreenKeyMapping();
      let completedCount = 0;

      screens.forEach((screen) => {
        const key = screenMapping[screen];
        if (status[key] === true) {
          completedCount += 1;
        }
      });

      const percent = Math.round((completedCount / screens.length) * 100);

      setCompletedSteps(completedCount);
      setCompletedPercent(percent);
    } catch (error) {
      console.error("Error fetching application status", error);
    }
  };

  const getScreenKeyMapping = () => ({
    "Personal Details": "IsAapplicationDetailsCompleted",
    "Proof Of Trust": "IsProofofTrustCompleted",
    "Identification Details": "IsAapplicationIdentificationCompleted",
    "Cob Details": "IsCoborrowerDetailsCompleted",
    "Cob Identification": "IsCoborrowerIdentificationCompleted",
    "Document Upload": "IsDocumentUploadCompleted",
    "Income Source": "IsIncomesourceCompleted",
    "Expenses": "IsExpensesCompleted",
    "Balance Sheet Asset": "IsBalancesheetAssetCompleted",
    "Balance Sheet Total Asset": "IsBalancesheetTotalAssetCompleted",
    "Balance Sheet Total Liability":
      "IsBalancesheetTotalLiabiltyCompleted",
    "Questionnaire": "IsQuestionairCompleted",
  });

  const getFilteredScreens = (typeId) => {
    switch (typeId) {
      case 1:
        return [
          "Personal Details",
          "Identification Details",
          "Document Upload",
          "Income Source",
          "Expenses",
          "Balance Sheet Asset",
          "Balance Sheet Total Asset",
          "Balance Sheet Total Liability",
          "Questionnaire",
        ];
      case 4:
        return [
          "Personal Details",
          "Identification Details",
          "Cob Details",
          "Cob Identification",
          "Document Upload",
          "Income Source",
          "Expenses",
          "Balance Sheet Asset",
          "Balance Sheet Total Asset",
          "Balance Sheet Total Liability",
          "Questionnaire",
        ];
      case 3:
        return [
          "Personal Details",
          "Proof Of Trust",
          "Identification Details",
          "Document Upload",
          "Income Source",
          "Expenses",
          "Balance Sheet Asset",
          "Balance Sheet Total Asset",
          "Balance Sheet Total Liability",
          "Questionnaire",
        ];
      case 2:
        return [
          "Personal Details",
          "Proof Of Trust",
          "Document Upload",
          "Income Source",
          "Expenses",
          "Balance Sheet Asset",
          "Balance Sheet Total Asset",
          "Balance Sheet Total Liability",
          "Questionnaire",
        ];
      case 5: // Legal Entity
        return [
          "Personal Details",
          "Document Upload",
          "Income Source",
          "Expenses",
          "Balance Sheet Asset",
          "Balance Sheet Total Asset",
          "Balance Sheet Total Liability",
          "Questionnaire",
        ];
      default:
        return [];
    }
  };
console.log("Completed Percent:", completedPercent);
  return (
    <div className="app-progress-wrapper">
      <div className="app-progress-header">
        <span className="title">Application Registration</span>
        <span className="percent">{completedPercent}%</span>
        
         
      </div>

      {completedPercent === 100 && (
        <div className="complete">
          <span>Complete</span>
        </div>
      )}

      <Tooltip title={`Application Workflow Progress: ${completedPercent}%`}>
        <Progress
          percent={completedPercent}
          showInfo={false}
          strokeWidth={4}
        />
      </Tooltip>

      <div className="step-text">
        Step {completedSteps} of {totalSteps}
      </div>
    </div>
  );
};

export default ApplicationProgressBar;

